export default {
  'pages.layouts.userLayout.title':
    'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.searchTable.selectToDelete': '请选择要删除的项',

  'pages.403.subTitle': '抱歉，您没有权限访问此页面。',
  'pages.403.buttonText': '返回首页',

  // 任务相关字段
  'pages.task.owner': '产权人',
  'pages.task.propertyCert': '产权证号',
  'pages.task.region': '省市区',
  'pages.task.cardAddress': '证载地址',
  'pages.task.houseUsage': '证载房屋用途',
  'pages.task.landUsage': '证载土地用途',
  'pages.task.houseRightNature': '证载房屋权利性质',
  'pages.task.landRightNature': '证载土地权利性质',
  'pages.task.houseRightType': '证载房屋权利类型',
  'pages.task.landRightType': '证载土地权利类型',
  'pages.task.landExpiry': '土地使用权终止日期',
  'pages.task.building': '楼盘',
  'pages.task.buildingNo': '楼栋号',
  'pages.task.unitNo': '单元号',
  'pages.task.householdNo': '户号',
  'pages.task.bedroom': '居室',
  'pages.task.hall': '厅',
  'pages.task.kitchen': '厨房',
  'pages.task.toilet': '卫生间',
  'pages.task.buildingArea': '房屋建筑面积(㎡)',
  'pages.task.sharedLandArea': '分摊土地面积(㎡)',
  'pages.task.sharedBuildingArea': '分摊建筑面积(㎡)',
  'pages.task.landArea': '土地使用权面积(㎡)',
  'pages.task.innerArea': '套内面积(㎡)',
  'pages.task.actualUsedType': '实际用途',
  'pages.task.usageStatus': '使用状况',
  'pages.task.floorPosition': '所在楼层',
  'pages.task.totalFloors': '总楼层',
  'pages.task.finishTime': '建成年份',
  'pages.task.purchaseDuration': '购买年限',
  'pages.task.taxPolicy': '净值方案',
  'pages.task.shopsType': '商铺类型',
  'pages.task.shopsAmount': '商铺租金(元/月)',
  'pages.task.coOwnership': '共有人',
  'pages.task.coOwnershipCircumstance': '共有情况',
  'pages.task.ownershipInfo': '权属信息',
  'pages.task.smartRecognition': '智能识别',
  'pages.task.smartCalculation': '智能测算',
  'pages.task.comparativeData': '比价资料',
  'pages.task.calculationTable': '测算表',
  'pages.task.downloadReportPDF': '下载报告PDF',
  'pages.task.viewReport': '查看报告',
  'pages.task.review.totalAmountPrecision': '总价展示精度',
  'pages.task.review.precisionOnes': '个位',
  'pages.task.review.precisionTens': '十位',
  'pages.task.review.precisionHundreds': '百位',
  'pages.task.review.precisionThousands': '千位',
  'pages.task.review.precisionTenThousands': '万位',
  'pages.task.review.precisionHundredThousands': '十万位',
  'pages.task.review.precisionMillions': '百万位',
  'pages.task.review.savePrecisionFail': '保存总价精度失败',
  'pages.netValueSolution.customParams.button': '自定义参数',
  'pages.netValueSolution.customParams.title': '自定义参数',
  'pages.netValueSolution.customParams.back': '返回',
  'pages.netValueSolution.customParams.col.name': '展示名称',
  'pages.netValueSolution.customParams.col.paramKey': '业务键',
  'pages.netValueSolution.customParams.col.paramValue': '参数值',
  'pages.netValueSolution.customParams.col.order': '排序',
  'pages.netValueSolution.customParams.col.action': '操作',
  'pages.netValueSolution.customParams.col.deductionItem': '扣减项',
  'pages.netValueSolution.customParams.col.calcCondition': '计算条件',
  'pages.netValueSolution.customParams.col.calcFormula': '计算公式',
  'pages.netValueSolution.customParams.action.edit': '编辑',
  'pages.netValueSolution.customParams.action.delete': '删除',
  'pages.netValueSolution.planDetailLoading': '正在加载净值方案详情…',
  'pages.netValueSolution.customParams.missingPlanId': '缺少净值方案信息，已返回列表',
  'pages.netValueSolution.customParams.needSavedPlan': '请先保存净值方案后再配置自定义参数',
  'pages.netValueSolution.customParams.addButton': '新增自定义参数',
  'pages.netValueSolution.customParams.modalAddTitle': '新增自定义参数',
  'pages.netValueSolution.customParams.modalEditTitle': '编辑自定义参数',
  'pages.netValueSolution.customParams.confirmDelete': '确定删除该自定义参数吗？',
  'pages.netValueSolution.customParams.loadListFailed': '加载自定义参数失败',
  'pages.netValueSolution.customParams.saveSuccess': '保存成功',
  'pages.netValueSolution.customParams.saveFailed': '保存失败',
  'pages.netValueSolution.customParams.saving': '保存中…',
  'pages.netValueSolution.customParams.loadingDetail': '加载详情中…',
  'pages.netValueSolution.customParams.loadDetailFailed': '加载自定义参数详情失败',
  'pages.netValueSolution.customParams.deleteSuccess': '删除成功',
  'pages.netValueSolution.customParams.deleteFailed': '删除失败',
  'pages.netValueSolution.customParams.rules.name': '请输入展示名称',
  'pages.netValueSolution.customParams.rules.paramKey': '请输入业务键',
  'pages.netValueSolution.customParams.rules.orderIndex': '请输入排序',
  'pages.netValueSolution.deduction.modalAdd': '新增扣减项',
  'pages.netValueSolution.deduction.modalEdit': '编辑扣减项',
  'pages.netValueSolution.deduction.modalAddTaxRate': '添加税率',
  'pages.netValueSolution.table.confirmDelete': '确定要删除这条记录吗？',
  'pages.netValueSolution.table.confirmDeleteWithChildren':
    '确定要删除这条记录吗？删除后将同时删除所有相关的子记录。',
  'pages.netValueSolution.formulaConfig.title': '配置计算公式',
  'pages.netValueSolution.add.pageTitle': '新增净值方案',
  'pages.netValueSolution.edit.pageTitle': '编辑净值方案',
  'pages.netValueSolution.taxCard.title': '税费扣减项',
  'pages.netValueSolution.conditionRequired': '计算条件至少需要选择一个',
  'pages.netValueSolution.taxModal.deductionNameRequired': '请输入扣减项名称',
  'pages.netValueSolution.taxModal.childConditionRequired': '子项请至少选择或填写一项计算条件后再保存',
  'pages.netValueSolution.taxModal.formulaRequired': '请先配置计算公式后再保存',
  'pages.netValueSolution.message.savePlanSuccess': '保存净值方案成功',
  'pages.netValueSolution.message.addDeductionSuccess': '新增扣减项成功',
  'pages.netValueSolution.message.loadDetailFailed': '加载净值方案详情失败',
  'pages.netValueSolution.message.defaultItemCannotDelete': '默认的增减项不允许删除',
  'pages.netValueSolution.message.taxRateMax100': '税率最大不允许超过100',
  'pages.netValueSolution.message.dataAbnormalRetry': '数据异常，请关闭后重试',
  'pages.netValueSolution.message.updateTaxRateSuccess': '更新税率成功',
  'pages.netValueSolution.message.addTaxRateSuccess': '添加税率成功',
  'pages.netValueSolution.message.checkRequiredFieldsEmpty': '请检查必填项不能为空',
  'pages.netValueSolution.message.checkRequiredFieldsWithDetails': '请检查以下必填项：{details}',
  'pages.netValueSolution.message.selectAtLeastOneDeduction': '请至少勾选一条扣减项，否则无法提交',
  'pages.netValueSolution.message.unknownField': '未知字段',
  'pages.netValueSolution.addForm.label.cityName': '适用城市',
  'pages.netValueSolution.addForm.label.districtCode': '适用区县',
  'pages.netValueSolution.addForm.label.provinceCode': '适用省份',
  'pages.netValueSolution.addForm.label.bankId': '适用渠道',
  'pages.netValueSolution.addForm.label.businessLines': '业务领域',
  'pages.netValueSolution.addForm.label.businessType': '业务类型',
  'pages.netValueSolution.addForm.label.netWorthName': '抵押净值',
  'pages.netValueSolution.addForm.label.organizationId': '适用机构',
  'pages.netValueSolution.addForm.rules.selectCity': '请选择适用城市',
  'pages.netValueSolution.addForm.rules.selectProvince': '请选择适用省份',
  'pages.netValueSolution.addForm.rules.selectBank': '请选择适用渠道',
  'pages.netValueSolution.addForm.rules.selectBusinessLines': '请选择业务领域',
  'pages.netValueSolution.addForm.rules.selectBusinessType': '请选择业务类型',
  'pages.netValueSolution.addForm.rules.selectNetWorth': '请选择抵押净值',
  'pages.netValueSolution.addForm.rules.selectOrganization': '请选择适用机构',
  'pages.netValueSolution.addForm.placeholder.selectProvince': '请选择省份',
  'pages.netValueSolution.addForm.placeholder.selectCity': '请选择城市',
  'pages.netValueSolution.addForm.placeholder.selectDistrict': '请选择区县',
  'pages.netValueSolution.addForm.placeholder.selectBank': '请选择适用渠道',
  'pages.netValueSolution.addForm.placeholder.selectBusinessLines': '请选择业务领域',
  'pages.netValueSolution.addForm.placeholder.selectBusinessType': '请选择业务类型',
  'pages.netValueSolution.addForm.placeholder.selectNetWorth': '请选择抵押净值',
  'pages.netValueSolution.addForm.placeholder.selectOrganization': '请选择适用机构',
  'pages.netValueSolution.addForm.alertLine1':
    '默认方式为系统设定的计算方式,当存在不符合用户所设定的计算方式,则系统会使用默认方式计算相关的税费值。',
  'pages.netValueSolution.addForm.alertLine2': '税费扣减项的添加,可以添加自定义的扣减项目,计算方式为默认方式。',
  'pages.netValueSolution.addForm.alertLine3': '税费项列表的添加,则添加相对应税种的多种情况下的税率。',
  'pages.netValueSolution.addNewDeduction': '新增扣减项',

  'pages.netValueSolution.list.title': '净值方案',
  'pages.netValueSolution.list.addButton': '新增净值方案',
  'pages.netValueSolution.list.loadListFailed': '获取净值方案列表失败',
  'pages.netValueSolution.list.loadListFailedRetry': '获取净值方案列表失败，请重试',
  'pages.netValueSolution.list.missingPlanId': '无法获取净值方案 ID',
  'pages.netValueSolution.list.confirmDeleteTitle': '确认删除',
  'pages.netValueSolution.list.confirmDeleteContent': '删除后数据将无法恢复，确定要删除该净值方案吗？',
  'pages.netValueSolution.list.deleteItemLabel': '净值方案「{name}」',
  'pages.netValueSolution.list.edit': '编辑',
  'pages.netValueSolution.list.copy': '复制',
  'pages.netValueSolution.list.col.province': '适用省份',
  'pages.netValueSolution.list.col.city': '适用城市',
  'pages.netValueSolution.list.col.district': '适用区县',
  'pages.netValueSolution.list.col.bank': '适用渠道',
  'pages.netValueSolution.list.col.businessLines': '业务领域',
  'pages.netValueSolution.list.col.businessType': '业务类型',
  'pages.netValueSolution.list.col.organization': '所属机构',
  'pages.netValueSolution.list.col.netWorthName': '净值名称',
  'pages.netValueSolution.list.col.deductItems': '税费扣减项',
  'pages.netValueSolution.list.col.action': '操作',
  'pages.netValueSolution.list.ph.province': '请选择省份',
  'pages.netValueSolution.list.ph.city': '请选择城市',
  'pages.netValueSolution.list.ph.district': '请选择区县',
  'pages.netValueSolution.list.ph.bank': '请选择适用渠道',
  'pages.netValueSolution.list.ph.businessLines': '请选择业务领域',
  'pages.netValueSolution.list.ph.businessType': '请选择业务类型',
  'pages.netValueSolution.list.ph.organization': '请选择所属机构',
  'pages.netValueSolution.list.ph.netWorthName': '请选择净值名称',
  'pages.netValueSolution.list.paginationTotal': '第 {start}-{end} 条/共 {total} 条',

  'pages.reportTemplate.list.title': '模板配置列表',
  'pages.reportTemplate.list.addButton': '新增报告配置',
  'pages.reportTemplate.list.loadListFailedRetry': '获取报告模板配置列表失败，请重试',
  'pages.reportTemplate.list.unlimited': '不限',
  'pages.reportTemplate.list.configTemplate': '配置模板',
  'pages.reportTemplate.list.editRules': '编辑规则',
  'pages.reportTemplate.list.confirmDeleteTitle': '确认删除',
  'pages.reportTemplate.list.confirmDeleteContent': '删除后该配置及其全部版本、映射数据将无法恢复，确定继续吗？',
  'pages.reportTemplate.list.deleteItemLabel': '报告模板配置「{name}」',
  'pages.reportTemplate.list.statusNormal': '正常',
  'pages.reportTemplate.list.statusEnabled': '已启用',
  'pages.reportTemplate.list.statusPending': '待启用',
  'pages.reportTemplate.list.statusArchived': '已归档',
  'pages.reportTemplate.list.col.templateName': '模板名称',
  'pages.reportTemplate.list.col.organization': '所属机构',
  'pages.reportTemplate.list.col.province': '适用省份',
  'pages.reportTemplate.list.col.city': '适用城市',
  'pages.reportTemplate.list.col.district': '适用区县',
  'pages.reportTemplate.list.col.street': '适用街道',
  'pages.reportTemplate.list.col.bank': '所属渠道',
  'pages.reportTemplate.list.col.businessLines': '业务领域',
  'pages.reportTemplate.list.col.businessType': '业务类型',
  'pages.reportTemplate.list.col.businessSubType': '子业务类型',
  'pages.reportTemplate.list.col.landRightNature': '土地性质',
  'pages.reportTemplate.list.col.actualUse': '实际用途',
  'pages.reportTemplate.list.col.status': '生效状态',
  'pages.reportTemplate.list.col.updateTime': '更新时间',
  'pages.reportTemplate.list.col.action': '操作',
  'pages.reportTemplate.list.ph.templateName': '请输入模板名称',
  'pages.reportTemplate.list.ph.organization': '请选择所属机构',
  'pages.reportTemplate.list.ph.province': '请选择省份',
  'pages.reportTemplate.list.ph.city': '请选择城市',
  'pages.reportTemplate.list.ph.businessLines': '请选择业务领域',
  'pages.reportTemplate.list.ph.businessType': '请选择业务类型',
  'pages.reportTemplate.list.ph.businessSubType': '请选择子业务类型',
  'pages.reportTemplate.list.ph.bank': '请选择所属渠道',
  'pages.reportTemplate.list.ph.landRightNature': '请输入土地性质',
  'pages.reportTemplate.list.ph.actualUse': '请选择实际用途',
  'pages.reportTemplate.list.ph.status': '请选择生效状态',
  'pages.reportTemplate.list.paginationTotal': '第 {start}-{end} 条/共 {total} 条',

  'pages.universalParams.title': '通用参数列表',
  'pages.universalParams.addButton': '新增通用参数',
  'pages.universalParams.col.orderIndex': '排序',
  'pages.universalParams.col.name': '参数名称',
  'pages.universalParams.col.description': '描述',
  'pages.universalParams.col.value': '值',
  'pages.universalParams.col.action': '操作',
  'pages.universalParams.loadListFailed': '加载列表失败',
  'pages.universalParams.loadDetailFailed': '获取详情失败',
  'pages.universalParams.confirmDeleteTitle': '确认删除',
  'pages.universalParams.confirmDeleteDesc': '确定删除参数「{name}」吗？',
  'pages.universalParams.modal.addTitle': '新增通用参数',
  'pages.universalParams.modal.editTitle': '编辑通用参数',
  'pages.universalParams.form.name': '参数名称',
  'pages.universalParams.form.namePlaceholder': '展示名称',
  'pages.universalParams.form.description': '描述',
  'pages.universalParams.form.descriptionPlaceholder': '可选',
  'pages.universalParams.form.value': '参数值（value）',
  'pages.universalParams.form.valuePlaceholder': 'tb_task_record.appraisal_value',
  'pages.universalParams.form.orderIndex': '排序',
  'pages.universalParams.form.orderPlaceholder': '数字越小越靠前',
  'pages.universalParams.rules.nameRequired': '请输入参数名称',
  'pages.universalParams.rules.valueRequired': '请输入参数值',
  'pages.universalParams.rules.valueFormat':
    '须为 tb_表名.字段名 格式（全小写与下划线），例如 tb_task_record.appraisal_value',
  'pages.universalParams.extra.valueHint':
    '公式中 PARAM 的 key 与此一致，必须为 tb_前缀表名.字段名，例如 tb_task_record.value',

  'pages.system.logs.headerTitle': '操作日志',
  'pages.system.logs.col.modelName': '操作模块',
  'pages.system.logs.col.apiName': '操作内容',
  'pages.system.logs.col.userName': '操作人',
  'pages.system.logs.col.requestIp': '请求IP',
  'pages.system.logs.col.status': '状态',
  'pages.system.logs.col.createTime': '操作时间',
  'pages.system.logs.col.timeRange': '操作时间',
  'pages.system.logs.ph.module': '请选择操作模块',
  'pages.system.logs.ph.userName': '请输入操作人',
  'pages.system.logs.fetchModulesFailed': '获取操作模块列表失败',

  'pages.system.permission.addButton': '新增权限',
  'pages.system.permission.col.name': '权限名称',
  'pages.system.permission.col.desc': '描述',
  'pages.system.permission.col.action': '操作',
  'pages.system.permission.configureApi': '配置API',
  'pages.system.permission.deleteItemName': '权限"{name}"',
  'pages.system.permission.batchSelected': '选中的 {count} 个权限',
  'pages.system.permission.apiConfigSuccess': 'API权限配置成功',
  'pages.system.permission.apiConfigFailed': 'API权限配置失败',
  'pages.system.permission.apiConfigFailedRetry': 'API权限配置失败，请重试',
  'pages.system.permission.apiModalTitle': '配置API权限 - {name}',
  'pages.system.permission.selectToDelete': '请选择要删除的权限',

  'pages.system.role.col.name': '角色名称',
  'pages.system.role.col.description': '角色描述',
  'pages.system.role.col.action': '操作',
  'pages.system.role.deleteItemName': '角色【{name}】',
  'pages.system.role.batchSelected': '选中的 {count} 个角色',
  'pages.system.role.configurePermission': '配置权限',
  'pages.system.role.configureMenuPermission': '配置菜单权限',
  'pages.system.role.apiConfigSuccess': 'API权限配置成功',
  'pages.system.role.permissionConfigSuccess': '权限配置成功',
  'pages.system.role.menuPermissionConfigSuccess': '菜单权限配置成功',
  'pages.system.role.deleteFailedCount': '{count} 个角色删除失败',

  'pages.system.menu.col.name': '权限名称',
  'pages.system.menu.col.code': '权限Code',
  'pages.system.menu.col.action': '操作',
  'pages.system.menu.addButton': '新增菜单',
  'pages.system.menu.addSubMenu': '新增子菜单',
  'pages.system.menu.deleteItemName': '菜单"{name}"',

  'pages.system.dept.pageTitle': '部门管理',
  'pages.system.dept.refresh': '刷新',
  'pages.system.dept.addDept': '新增部门',
  'pages.system.dept.addChildDept': '新增子部门',
  'pages.system.dept.editDept': '编辑部门',
  'pages.system.dept.treeTitle': '部门树',
  'pages.system.dept.orgCount': '共 {count} 个机构',
  'pages.system.dept.emptyTree': '暂无部门数据',
  'pages.system.dept.detailDept': '部门详情',
  'pages.system.dept.detailOrg': '机构详情',
  'pages.system.dept.edit': '编辑',
  'pages.system.dept.delete': '删除',
  'pages.system.dept.label.deptName': '部门名称',
  'pages.system.dept.label.deptId': '部门ID',
  'pages.system.dept.label.parentDept': '上级部门',
  'pages.system.dept.label.status': '状态',
  'pages.system.dept.label.childCount': '子部门数量',
  'pages.system.dept.label.ownerOrg': '所属机构/客户',
  'pages.system.dept.label.orgName': '机构/客户名称',
  'pages.system.dept.label.orgId': '机构/客户ID',
  'pages.system.dept.label.ownerType': '类型',
  'pages.system.dept.type.organization': '机构',
  'pages.system.dept.type.customer': '客户',
  'pages.system.dept.status.enabled': '启用',
  'pages.system.dept.status.disabled': '禁用',
  'pages.system.dept.parentRoot': '无（根部门）',
  'pages.system.dept.selectNodeHint': '请选择左侧的部门节点或机构节点',
  'pages.system.dept.unnamedDept': '未命名部门',
  'pages.system.dept.ungrouped': '未分组',
  'pages.system.dept.unnamed': '未命名',
  'pages.system.dept.fetchTreeFail': '获取部门树失败',
  'pages.system.dept.fetchTreeFailRetry': '获取部门树失败，请稍后重试',
  'pages.system.dept.cannotDeleteInvalid': '无法删除无效的部门节点',
  'pages.system.dept.cannotDeleteRoot': '根部门不允许删除',
  'pages.system.dept.defaultItemName': '部门',
  'pages.system.dept.deleteTitle': '确认删除该部门吗？',
  'pages.system.dept.deleteContent': '删除后无法恢复，该部门的子部门也会受到影响。',
  'pages.system.dept.deleteSuccess': '删除成功',
  'pages.system.dept.deleteFail': '删除失败',
  'pages.system.dept.deleteFailRetry': '删除失败，请稍后再试',
  'pages.system.dept.editMissingOwner': '编辑部门时缺少所属机构/客户信息，请刷新后重试',
  'pages.system.dept.saveSuccessEdit': '编辑部门成功',
  'pages.system.dept.saveSuccessAdd': '新增部门成功',
  'pages.system.dept.saveFail': '保存失败',
  'pages.system.dept.form.name': '部门名称',
  'pages.system.dept.form.nameRequired': '请输入部门名称',
  'pages.system.dept.form.nameMax': '部门名称不能超过50个字符',
  'pages.system.dept.form.namePlaceholder': '请输入部门名称',
  'pages.system.dept.form.ownerOrg': '所属机构',
  'pages.system.dept.form.ownerOrgRequired': '请选择所属机构',
  'pages.system.dept.form.ownerOrgPlaceholder': '请选择所属机构',
  'pages.system.dept.form.ownerOrgCustomer': '所属机构/客户',
  'pages.system.dept.form.ownerSelectedPlaceholder': '已选择机构/客户',
  'pages.system.dept.form.parentDept': '上级部门',
  'pages.system.dept.form.parentDeptPlaceholder': '请选择上级部门',

  'pages.system.district.pageTitle': '行政区划管理',
  'pages.system.district.refresh': '刷新',
  'pages.system.district.treeTitle': '行政区划树',
  'pages.system.district.nodeCount': '共 {count} 个根节点',
  'pages.system.district.treeSearchPlaceholder': '搜索行政区名称或编码',
  'pages.system.district.treeSearchEmpty': '未找到匹配的行政区划',
  'pages.system.district.emptyTree': '暂无行政区划数据',
  'pages.system.district.detailTitle': '行政区划详情',
  'pages.system.district.label.name': '行政区名称',
  'pages.system.district.label.adcode': '行政区编码',
  'pages.system.district.label.level': '级别',
  'pages.system.district.label.parentDistrict': '上级行政区',
  'pages.system.district.label.dataSource': '数据来源',
  'pages.system.district.label.status': '状态',
  'pages.system.district.label.sortOrder': '排序',
  'pages.system.district.label.childCount': '子节点数量',
  'pages.system.district.level.province': '省',
  'pages.system.district.level.city': '市',
  'pages.system.district.level.district': '区县',
  'pages.system.district.level.street': '街道',
  'pages.system.district.dataSource.amap': '高德同步',
  'pages.system.district.dataSource.manual': '手动维护',
  'pages.system.district.status.enabled': '启用',
  'pages.system.district.status.disabled': '禁用',
  'pages.system.district.parentRoot': '无（根节点）',
  'pages.system.district.selectNodeHint': '请选择左侧的行政区划节点',
  'pages.system.district.unnamed': '未命名行政区',
  'pages.system.district.fetchTreeFail': '获取行政区划树失败',
  'pages.system.district.fetchTreeFailRetry': '获取行政区划树失败，请稍后重试',
  'pages.system.district.fetchStreetsFailRetry': '加载街道数据失败，请稍后重试',
  'pages.system.district.invalidParentLevel': '所选上级区划级别不正确，请重新选择',
  'pages.system.district.addDistrict': '新增行政区划',
  'pages.system.district.addChildDistrict': '新增下级区划',
  'pages.system.district.editDistrict': '编辑行政区划',
  'pages.system.district.edit': '编辑',
  'pages.system.district.delete': '删除',
  'pages.system.district.cannotDeleteInvalid': '无法删除无效的行政区划节点',
  'pages.system.district.cannotDeleteHasChildren': '存在下级区划时不允许删除',
  'pages.system.district.cannotAddChildStreet': '街道级区划不允许新增下级',
  'pages.system.district.defaultItemName': '行政区划',
  'pages.system.district.deleteTitle': '确认删除该行政区划吗？',
  'pages.system.district.deleteContent': '删除后无法恢复，请确认操作。',
  'pages.system.district.deleteSuccess': '删除成功',
  'pages.system.district.deleteFail': '删除失败',
  'pages.system.district.deleteFailRetry': '删除失败，请稍后再试',
  'pages.system.district.editMissingId': '编辑时缺少区划 ID，请刷新后重试',
  'pages.system.district.saveSuccessEdit': '编辑行政区划成功',
  'pages.system.district.saveSuccessAdd': '新增行政区划成功',
  'pages.system.district.saveFail': '保存失败',
  'pages.system.district.form.name': '行政区名称',
  'pages.system.district.form.nameRequired': '请输入行政区名称',
  'pages.system.district.form.nameMax': '行政区名称不能超过100个字符',
  'pages.system.district.form.namePlaceholder': '请输入行政区名称',
  'pages.system.district.form.level': '级别',
  'pages.system.district.form.levelRequired': '请选择级别',
  'pages.system.district.form.levelPlaceholder': '请选择级别',
  'pages.system.district.form.parentDistrict': '上级行政区',
  'pages.system.district.form.parentRequired': '请选择上级行政区',
  'pages.system.district.form.parentPlaceholder': '请选择上级行政区',
  'pages.system.district.form.status': '状态',
  'pages.system.district.form.sortOrder': '排序',
  'pages.system.district.form.provinceShortName': '省份简称',
  'pages.system.district.form.provinceShortNamePlaceholder': '请输入省份简称',
  'pages.system.district.form.citycode': '城市编码',
  'pages.system.district.form.citycodePlaceholder': '请输入城市编码',
  'pages.system.district.form.plateNumber': '车牌编号',
  'pages.system.district.form.plateNumberPlaceholder': '请输入车牌编号',
  'pages.system.district.form.center': '中心点坐标',
  'pages.system.district.form.centerPlaceholder': '格式：经度,纬度',
  'pages.system.district.form.polyline': '边界坐标',
  'pages.system.district.form.polylinePlaceholder': '请输入行政区边界坐标',

  'pages.operations.statTotalCustomers': '总客户数',
  'pages.operations.statNewThisMonth': '本月新增',
  'pages.operations.statPendingTasks': '待处理任务',
  'pages.operations.statReportsDone': '已完成报告',
  'pages.operations.taskRateTitle': '任务完成率',
  'pages.operations.recentActivityTitle': '最近活动',
  'pages.operations.col.time': '时间',
  'pages.operations.col.activity': '活动',
  'pages.operations.col.operator': '操作人',
  'pages.operations.col.status': '状态',
  'pages.operations.taskName.evaluation': '客户评估',
  'pages.operations.taskName.report': '报告生成',
  'pages.operations.taskName.finance': '财务审核',
  'pages.operations.taskName.maintenance': '系统维护',
  'pages.operations.status.done': '已完成',
  'pages.operations.status.inProgress': '进行中',
  'pages.operations.systemStatusTitle': '系统状态概览',
  'pages.operations.cpuUsage': 'CPU使用率',
  'pages.operations.memoryUsage': '内存使用率',
  'pages.operations.diskUsage': '磁盘使用率',
  'pages.operations.demo.action1': '新增客户评估任务',
  'pages.operations.demo.action2': '完成财务报告审核',
  'pages.operations.demo.action3': '系统维护更新',
  'pages.operations.demo.action4': '客户满意度调查',
  'pages.operations.demo.user1': '张三',
  'pages.operations.demo.user2': '李四',
  'pages.operations.demo.user3': '王五',
  'pages.operations.demo.user4': '赵六',

  'pages.finance.tooltip.view': '查看详情',
  'pages.finance.tooltip.edit': '编辑',
  'pages.finance.tooltip.delete': '删除',
  'pages.finance.stat.totalIncome': '总收入',
  'pages.finance.stat.totalExpense': '总支出',
  'pages.finance.stat.netIncome': '净收入',
  'pages.finance.modal.add': '新增财务记录',
  'pages.finance.modal.edit': '编辑财务记录',
  'pages.finance.addRecord': '新增记录',
  'pages.finance.paginationTotal': '第 {start}-{end} 条/共 {total} 条记录',

  'pages.platform.tooltip.view': '查看详情',
  'pages.platform.tooltip.edit': '编辑',
  'pages.platform.tooltip.delete': '删除',
  'pages.platform.modal.add': '新增维护记录',
  'pages.platform.modal.edit': '编辑维护记录',
  'pages.platform.addRecord': '新增维护',
  'pages.platform.paginationTotal': '共 {total} 条记录',
  'pages.platform.column.id': '维护ID',
  'pages.platform.column.title': '标题',
  'pages.platform.column.type': '类型',
  'pages.platform.column.priority': '优先级',
  'pages.platform.column.status': '状态',
  'pages.platform.column.progress': '进度',
  'pages.platform.column.assignee': '负责人',
  'pages.platform.column.createTime': '创建时间',
  'pages.platform.column.estimatedTime': '预计完成',
  'pages.platform.column.action': '操作',
  'pages.platform.overview.ok': '系统正常',
  'pages.platform.overview.running': '运行中',
  'pages.platform.overview.attention': '需要关注',
  'pages.platform.overview.error': '异常',
  'pages.platform.alert.title': '系统状态监控',
  'pages.platform.alert.cpu': 'CPU使用率',
  'pages.platform.alert.memory': '内存使用率',
  'pages.platform.alert.disk': '磁盘使用率',
  'pages.platform.alert.network': '网络状态',
  'pages.platform.alert.networkOk': '正常',
  'pages.platform.filter.searchPlaceholder': '搜索维护标题或描述',
  'pages.platform.filter.typePlaceholder': '选择类型',
  'pages.platform.filter.statusPlaceholder': '选择状态',
  'pages.platform.filter.priorityPlaceholder': '选择优先级',
  'pages.platform.filter.assigneePlaceholder': '负责人筛选',
  'pages.platform.type.all': '全部类型',
  'pages.platform.type.performance': '性能优化',
  'pages.platform.type.security': '安全维护',
  'pages.platform.type.hardware': '硬件维护',
  'pages.platform.status.all': '全部状态',
  'pages.platform.status.pending': '待开始',
  'pages.platform.status.ongoing': '进行中',
  'pages.platform.status.completed': '已完成',
  'pages.platform.priority.all': '全部优先级',
  'pages.platform.priority.high': '高',
  'pages.platform.priority.medium': '中',
  'pages.platform.priority.low': '低',
  'pages.platform.stat.total': '总维护数',
  'pages.platform.stat.completed': '已完成',
  'pages.platform.stat.inProgress': '进行中',
  'pages.platform.stat.pending': '待开始',
  'pages.platform.confirmDelete': '确认删除',
  'pages.platform.confirmDeleteContent': '确定要删除维护记录 {title} 吗？',
  'pages.platform.msg.deleteSuccess': '删除成功',
  'pages.platform.msg.updateSuccess': '更新成功',
  'pages.platform.msg.addSuccess': '添加成功',
  'pages.platform.form.title': '维护标题',
  'pages.platform.form.titleRequired': '请输入维护标题',
  'pages.platform.form.titlePlaceholder': '请输入维护标题',
  'pages.platform.form.type': '维护类型',
  'pages.platform.form.typeRequired': '请选择维护类型',
  'pages.platform.form.typePerformance': '性能优化',
  'pages.platform.form.typeSecurity': '安全维护',
  'pages.platform.form.typeHardware': '硬件维护',
  'pages.platform.form.typeSoftware': '软件更新',
  'pages.platform.form.priority': '优先级',
  'pages.platform.form.priorityRequired': '请选择优先级',
  'pages.platform.form.assignee': '负责人',
  'pages.platform.form.assigneeRequired': '请输入负责人',
  'pages.platform.form.assigneePlaceholder': '请输入负责人',
  'pages.platform.form.estimatedTime': '预计完成时间',
  'pages.platform.form.estimatedTimeRequired': '请选择预计完成时间',
  'pages.platform.form.estimatedTimePlaceholder': '如: 2024-01-20',
  'pages.platform.form.description': '维护描述',
  'pages.platform.form.descriptionRequired': '请输入维护描述',
  'pages.platform.form.descriptionPlaceholder': '请输入维护描述',
  'pages.platform.form.status': '状态',

  'pages.activity.tooltip.view': '查看详情',
  'pages.activity.tooltip.edit': '编辑',
  'pages.activity.tooltip.delete': '删除',
  'pages.activity.modal.add': '新增活动',
  'pages.activity.modal.edit': '编辑活动',
  'pages.activity.addRecord': '新增活动',
  'pages.activity.paginationTotal': '共 {total} 条记录',
  'pages.activity.column.id': '活动ID',
  'pages.activity.column.title': '活动标题',
  'pages.activity.column.type': '类型',
  'pages.activity.column.startTime': '开始时间',
  'pages.activity.column.endTime': '结束时间',
  'pages.activity.column.location': '地点',
  'pages.activity.column.status': '状态',
  'pages.activity.column.participants': '参与人数',
  'pages.activity.column.budget': '预算',
  'pages.activity.column.organizer': '组织者',
  'pages.activity.column.action': '操作',
  'pages.activity.stat.total': '总活动数',
  'pages.activity.stat.inProgress': '进行中',
  'pages.activity.stat.registering': '报名中',
  'pages.activity.stat.ended': '已结束',
  'pages.activity.filter.searchPlaceholder': '搜索活动标题或组织者',
  'pages.activity.filter.typePlaceholder': '选择类型',
  'pages.activity.filter.statusPlaceholder': '选择状态',
  'pages.activity.filter.locationPlaceholder': '地点筛选',
  'pages.activity.type.all': '全部类型',
  'pages.activity.type.customer': '客户活动',
  'pages.activity.type.training': '技术培训',
  'pages.activity.type.meeting': '内部会议',
  'pages.activity.status.all': '全部状态',
  'pages.activity.status.planning': '策划中',
  'pages.activity.status.registration': '报名中',
  'pages.activity.status.ongoing': '进行中',
  'pages.activity.status.ended': '已结束',
  'pages.activity.rangeStart': '开始日期',
  'pages.activity.rangeEnd': '结束日期',
  'pages.activity.confirmDelete': '确认删除',
  'pages.activity.confirmDeleteContent': '确定要删除活动 {title} 吗？',
  'pages.activity.msg.deleteSuccess': '删除成功',
  'pages.activity.msg.updateSuccess': '更新成功',
  'pages.activity.msg.addSuccess': '添加成功',
  'pages.activity.form.title': '活动标题',
  'pages.activity.form.titleRequired': '请输入活动标题',
  'pages.activity.form.titlePlaceholder': '请输入活动标题',
  'pages.activity.form.type': '活动类型',
  'pages.activity.form.typeRequired': '请选择活动类型',
  'pages.activity.form.organizer': '组织者',
  'pages.activity.form.organizerRequired': '请输入组织者',
  'pages.activity.form.organizerPlaceholder': '请输入组织者',
  'pages.activity.form.startTime': '开始时间',
  'pages.activity.form.startTimeRequired': '请选择开始时间',
  'pages.activity.form.endTime': '结束时间',
  'pages.activity.form.endTimeRequired': '请选择结束时间',
  'pages.activity.form.location': '活动地点',
  'pages.activity.form.locationRequired': '请输入活动地点',
  'pages.activity.form.locationPlaceholder': '请输入活动地点',
  'pages.activity.form.maxParticipants': '最大参与人数',
  'pages.activity.form.maxParticipantsRequired': '请输入最大参与人数',
  'pages.activity.form.budget': '预算金额',
  'pages.activity.form.budgetRequired': '请输入预算金额',
  'pages.activity.form.activityStatus': '活动状态',

  // --- 核心业务：客户 / 任务 / 报告 / 台账 / 用户（列表与通用操作）---
  'pages.customer.list.col.customerName': '客户名称',
  'pages.customer.list.col.customerType': '客户类型',
  'pages.customer.list.col.province': '所处省份',
  'pages.customer.list.col.city': '所处城市',
  'pages.customer.list.col.district': '所处行政区',
  'pages.customer.list.col.organization': '所属机构',
  'pages.customer.list.col.status': '状态',
  'pages.customer.list.col.totalAmountPrecision': '价格精度',
  'pages.customer.list.col.contact': '客户联系人',
  'pages.customer.list.col.contactPhone': '客户联系方式',
  'pages.customer.list.col.createTime': '创建时间',
  'pages.customer.list.col.updateTime': '更新时间',
  'pages.customer.list.col.action': '操作',
  'pages.customer.list.confirmToggleTitle': '确认{action}',
  'pages.customer.list.confirmToggleContent': '确定要{action}该客户吗？',
  'pages.customer.list.itemNamed': '客户"{name}"',
  'pages.customer.list.batchItemName': '选中的 {count} 个客户',
  'pages.customer.list.batchContent': '删除后数据将无法恢复，确定要删除选中的客户吗？',
  'pages.customer.list.batchResultAllSuccess': '成功删除 {success} 个客户',
  'pages.customer.list.batchResultPartial': '成功删除 {success} 个客户，{fail} 个删除失败',
  'pages.customer.list.batchFailed': '批量删除失败',
  'pages.customer.list.exportOrgTemplate': '机构客户模版',
  'pages.customer.list.exportPersonalTemplate': '个人客户模版',
  'pages.customer.list.exportUserTemplate': '客户用户模版',
  'pages.customer.list.exportTemplate': '导出模板',
  'pages.customer.list.importCustomer': '导入客户',
  'pages.customer.list.importCustomerUser': '导入客户用户',
  'pages.customer.list.addCustomer': '新增客户',
  'pages.customer.list.fileNameOrgTemplate': '机构客户导入模版.xlsx',
  'pages.customer.list.fileNamePersonalTemplate': '个人客户导入模版.xlsx',
  'pages.customer.list.fileNameUserTemplate': '客户用户导入模版.xlsx',
  'pages.customer.list.deleteContent': '删除后数据将无法恢复，确定要删除该客户吗？',
  'pages.customer.list.toggleSuccess': '{action}成功',
  'pages.customer.list.toggleFail': '{action}失败',
  'pages.customer.list.batchAmountPrecision': '编辑价格精度 ({count})',
  'pages.customer.list.amountPrecisionBatchTitle': '批量编辑报告总价展示精度',
  'pages.customer.list.amountPrecisionBatchHint': '已选择 {count} 个客户',
  'pages.customer.list.amountPrecisionConfigMode': '配置方式',
  'pages.customer.list.amountPrecisionModeSet': '设置精度',
  'pages.customer.list.amountPrecisionModeClear': '清除客户配置',
  'pages.customer.list.amountPrecisionRequired': '请选择总价展示精度',
  'pages.customer.list.amountPrecisionNoCustomers': '未选择有效客户',
  'pages.customer.list.amountPrecisionBatchSuccess': '成功更新 {count} 个客户的价格精度配置',
  'pages.customer.list.amountPrecisionBatchPartial': '成功更新 {success} 个客户，{fail} 个失败',
  'pages.customer.list.amountPrecisionBatchFailed': '批量编辑价格精度失败',
  'pages.customer.list.amountPrecisionFailReason': '失败原因',

  'pages.taskMgmt.col.taskNumber': '任务编号',
  'pages.taskMgmt.col.reportNumber': '报告编号',
  'pages.taskMgmt.col.taskName': '任务名称',
  'pages.taskMgmt.col.taskKind': '任务类型',
  'pages.taskMgmt.taskKind.single': '单套',
  'pages.taskMgmt.taskKind.multi': '多套',
  'pages.taskMgmt.col.specialSituation': '特殊情况',
  'pages.taskMgmt.col.taskStatus': '任务状态',
  'pages.taskMgmt.col.creator': '创建人',
  'pages.taskMgmt.col.currentOperator': '当前操作人',
  'pages.taskMgmt.col.province': '所属省份',
  'pages.taskMgmt.col.city': '所属城市',
  'pages.taskMgmt.col.district': '所属行政区',
  'pages.taskMgmt.col.createTime': '创建时间',
  'pages.taskMgmt.col.action': '操作',
  'pages.taskMgmt.action.view': '查看',
  'pages.taskMgmt.action.edit': '编辑',
  'pages.taskMgmt.action.withdraw': '撤回',
  'pages.taskMgmt.withdrawTitle': '撤回',
  'pages.taskMgmt.withdrawConfirm': '确认撤回',
  'pages.taskMgmt.withdrawSuccess': '撤回复核成功',
  'pages.taskMgmt.withdrawCheckFail': '检查是否可撤回失败',
  'pages.taskMgmt.withdrawCheckFailRetry': '检查是否可撤回失败，请稍后重试',
  'pages.taskMgmt.withdrawFail': '撤回复核失败',
  'pages.taskMgmt.withdrawFailRetry': '撤回复核失败，请稍后重试',
  'pages.taskMgmt.withdrawNotAllowedTitle': '当前无法撤回',
  'pages.taskMgmt.withdrawNotAllowedDefault': '当前任务状态不允许撤回复核',
  'pages.taskMgmt.withdrawApproverLabel': '审批人',
  'pages.taskMgmt.withdrawApproverPlaceholder': '请输入姓名搜索或选择部门经理',
  'pages.taskMgmt.withdrawApproverRequired': '请选择审批人',
  'pages.taskMgmt.withdrawApproverNotFound': '未找到匹配的审批人',
  'pages.taskMgmt.withdrawCommentLabel': '撤回说明',
  'pages.taskMgmt.withdrawCommentPlaceholder': '请输入撤回说明',
  'pages.taskMgmt.withdrawCommentRequired': '请输入撤回说明',
  'pages.taskMgmt.unknownStatus': '未知状态',
  'pages.taskMgmt.createLoading': '正在创建任务…',
  'pages.taskMgmt.createFail': '创建任务失败，请重试',
  'pages.taskMgmt.deleteTitle': '确认删除',
  'pages.taskMgmt.deleteContent': '确定要删除任务"{name}"吗？',
  'pages.taskMgmt.noTaskId': '任务ID不存在，无法删除',
  'pages.taskMgmt.redoTitle': '确认重做',
  'pages.taskMgmt.redoContent': '确定要重做任务"{name}"吗？',
  'pages.taskMgmt.redoSuccess': '任务重做成功',
  'pages.taskMgmt.fetchListFail': '获取任务列表失败',
  'pages.taskMgmt.fetchListFailRetry': '获取任务列表失败，请重试',
  'pages.taskMgmt.modalAddTitle': '新增任务',
  'pages.taskMgmt.formTaskName': '任务名称',
  'pages.taskMgmt.formTaskNameMax': '任务名称不能超过100个字符',
  'pages.taskMgmt.formTaskNamePlaceholder': '请输入任务名称（可选）',
  'pages.taskMgmt.paginationTotal': '第 {start}-{end} 条/共 {total} 条',

  'pages.report.col.electronicCode': '电子报告提取码',
  'pages.report.col.estimateCode': '报告编号',
  'pages.report.col.taskName': '任务名称',
  'pages.report.col.taskKind': '任务类型',
  'pages.report.col.state': '任务状态',
  'pages.report.col.creator': '创建人',
  'pages.report.col.operator': '当前操作人',
  'pages.report.col.organization': '所属机构',
  'pages.report.col.province': '所属省份',
  'pages.report.col.city': '所属城市',
  'pages.report.col.district': '所属行政区',
  'pages.report.col.createTime': '创建时间',
  'pages.report.col.action': '操作',
  'pages.report.state.all': '全部',
  'pages.report.state.pendingFirst': '待一审',
  'pages.report.state.pendingSecond': '待二审',
  'pages.report.state.pendingThird': '待三审',
  'pages.report.state.pendingSeal': '待签章',
  'pages.report.state.pendingModify': '待修改',
  'pages.report.state.done': '已完成',
  'pages.report.state.pendingArchive': '待归档',
  'pages.report.state.void': '已作废',
  'pages.report.state.completedEnd': '已完结',
  'pages.report.state.pendingReview': '待审核',
  'pages.report.state.reviewed': '已审核',
  'pages.report.state.sealPending': '待签章',
  'pages.report.state.sealed': '已签章',
  'pages.report.process.pending': '待处理',
  'pages.report.process.done': '已处理',
  'pages.report.review.addDev': '新增报告功能开发中…',
  'pages.report.action.review': '审核',
  'pages.report.action.sign': '签章',
  'pages.report.action.redo': '重做',
  'pages.report.action.redoApprove': '重做审批',
  'pages.report.state.pendingRedoApproval': '重做审批中',
  'pages.report.redo.applyTitle': '重做申请',
  'pages.report.redo.approveTitle': '重做审批',
  'pages.report.redo.approverLabel': '重做审核人',
  'pages.report.redo.approverPlaceholder': '请输入姓名搜索或选择部门经理',
  'pages.report.redo.approverRequired': '请选择重做审核人',
  'pages.report.redo.approverNotFound': '未找到匹配的审核人',
  'pages.report.redo.reasonLabel': '重做原因',
  'pages.report.redo.reasonPlaceholder': '请输入重做原因（100字以内）',
  'pages.report.redo.reasonRequired': '请填写重做原因',
  'pages.report.redo.reasonMax': '重做原因不能超过100字',
  'pages.report.redo.applySuccess': '重做申请已提交',
  'pages.report.redo.applyFail': '重做申请提交失败',
  'pages.report.redo.approveFail': '重做审批提交失败',
  'pages.report.redo.approvePassSuccess': '重做审批已通过',
  'pages.report.redo.approveRejectSuccess': '重做审批已驳回',
  'pages.report.redo.approveResultLabel': '审批结果',
  'pages.report.redo.approveCommentLabel': '审批意见',
  'pages.report.redo.approveCommentPlaceholder': '请输入审批意见',
  'pages.report.redo.rejectCommentRequired': '驳回时请填写审批意见',
  'pages.report.redo.pass': '通过',
  'pages.report.redo.reject': '驳回',
  'pages.report.redo.noTaskId': '任务ID不存在，无法操作',

  'pages.ledger.list.title': '台账明细',
  'pages.ledger.list.fetchFail': '获取台账列表失败',
  'pages.ledger.list.directConnect': '直连',
  'pages.ledger.list.tokenRequired': '请输入三方平台的 token',
  'pages.ledger.list.syncFail': '同步失败',
  'pages.ledger.list.directConnectDone': '直连已完成',
  'pages.ledger.list.directConnectAlready': '当前台账已完成直连',
  'pages.ledger.list.initFail': '初始化失败',
  'pages.ledger.list.initNoFileId': '初始化未返回 fileId，无法保存绑定',
  'pages.ledger.list.saveBindFail': '保存与绑定失败',
  'pages.ledger.list.flowFail': '转交审核失败',
  'pages.ledger.list.flowTimeout': '审核流程超时，请稍后重试',
  'pages.ledger.list.editDirectFail': '编辑并直连失败',
  'pages.ledger.list.searchConfigSaved': '搜索项配置已保存',
  'pages.ledger.list.ph.province': '请选择省份',
  'pages.ledger.list.ph.city': '请选择城市',
  'pages.ledger.list.ph.district': '请选择区县',
  'pages.ledger.list.ph.street': '请选择街道',
  'pages.ledger.list.notFoundData': '暂无数据',
  'pages.ledger.list.notFoundSelectProvince': '请先选择省份',
  'pages.ledger.list.notFoundSelectCity': '请先选择城市',
  'pages.ledger.list.notFoundSelectDistrict': '请先选择区县',
  'pages.ledger.list.downloadTemplate': '正在下载模板…',
  'pages.ledger.list.templateFileName': '台账明细导入模板.xlsx',
  'pages.ledger.list.exporting': '正在导出数据…',
  'pages.ledger.list.exportSuccess': '导出成功',
  'pages.ledger.list.exportFail': '导出台账失败',

  'pages.ledger.list.batchDirectConnect': '批量直连',
  'pages.ledger.list.autoDirectConnect': '自动直连',
  'pages.ledger.list.batchDirectConnectHint': '将对已选 {count} 条合格记录发起批量直连',
  'pages.ledger.list.autoDirectConnectHint': '系统将自动筛选待直连记录并发起任务，处理范围由后端决定',
  'pages.ledger.list.directConnectTokenLabel': '用户 token（必填）',
  'pages.ledger.list.batchDirectConnectSkipped': '已跳过 {count} 条不符合直连条件的记录',
  'pages.ledger.list.batchDirectConnectNoEligible': '没有可直连的记录',
  'pages.ledger.list.batchDirectConnectStartFail': '批量直连任务启动失败',
  'pages.ledger.list.autoDirectConnectStartFail': '自动直连任务启动失败',
  'pages.ledger.list.autoDirectConnectNoRecords': '当前无待直连台账',
  'pages.ledger.list.directConnectSkippedCount': '有 {count} 条记录被跳过',
  'pages.ledger.list.directConnectJobTitle': '直连任务进度',
  'pages.ledger.list.directConnectTaskList': '直连任务',
  'pages.ledger.list.directConnectTaskListTitle': '直连任务列表',
  'pages.ledger.list.directConnectTaskListView': '查看进度',
  'pages.ledger.list.directConnectTaskListEmpty': '暂无直连任务',
  'pages.ledger.list.directConnectTaskType.BATCH': '批量直连',
  'pages.ledger.list.directConnectTaskType.AUTO': '自动直连',
  'pages.ledger.list.directConnectJobStatusLabel': '任务状态',
  'pages.ledger.list.directConnectJobTotal': '总数',
  'pages.ledger.list.directConnectJobSuccess': '成功',
  'pages.ledger.list.directConnectJobFailed': '失败',
  'pages.ledger.list.directConnectJobSkipped': '跳过',
  'pages.ledger.list.directConnectJobProcessing': '进行中',
  'pages.ledger.list.directConnectJobEmpty': '暂无明细',
  'pages.ledger.list.directConnectJobCompleted': '直连任务已全部成功',
  'pages.ledger.list.directConnectJobPartialFailed': '直连任务部分失败',
  'pages.ledger.list.directConnectJobFailedMessage': '直连任务失败',
  'pages.ledger.list.directConnectJobCancelled': '直连任务已终止',
  'pages.ledger.list.directConnectJobQueryFail': '查询直连进度失败',
  'pages.ledger.list.directConnectJobCloseTitle': '任务仍在进行中',
  'pages.ledger.list.directConnectJobCloseContent': '关闭后任务仍会在后台继续，确定关闭进度窗口吗？',
  'pages.ledger.list.directConnectCancelTask': '终止排队',
  'pages.ledger.list.directConnectCancelSuccess': '任务已终止',
  'pages.ledger.list.directConnectCancelFailed': '任务已开始执行，无法终止',
  'pages.ledger.list.directConnectTokenDigest': 'Token 摘要',
  'pages.ledger.list.directConnectCol.ledgerRecordId': '台账 ID',
  'pages.ledger.list.directConnectCol.taskId': '任务 ID',
  'pages.ledger.list.directConnectCol.taskType': '任务类型',
  'pages.ledger.list.directConnectCol.createTime': '创建时间',
  'pages.ledger.list.directConnectCol.status': '状态',
  'pages.ledger.list.directConnectCol.failureType': '失败分类',
  'pages.ledger.list.directConnectCol.failureReason': '失败原因',
  'pages.ledger.list.directConnectTaskStatus.QUEUED': '排队中',
  'pages.ledger.list.directConnectTaskStatus.RUNNING': '执行中',
  'pages.ledger.list.directConnectTaskStatus.CANCELLED': '已终止',
  'pages.ledger.list.directConnectTaskStatus.SUCCESS': '全部成功',
  'pages.ledger.list.directConnectTaskStatus.PARTIAL_FAILED': '部分失败',
  'pages.ledger.list.directConnectTaskStatus.FAILED': '全部失败',
  'pages.ledger.list.directConnectItemStatus.QUEUED': '排队中',
  'pages.ledger.list.directConnectItemStatus.RUNNING': '执行中',
  'pages.ledger.list.directConnectItemStatus.SUCCESS': '成功',
  'pages.ledger.list.directConnectItemStatus.FAILED': '失败',
  'pages.ledger.list.directConnectItemStatus.SKIPPED': '已跳过',
  'pages.ledger.list.directConnectFailureType.TOKEN_INVALID': 'token 失效',
  'pages.ledger.list.directConnectFailureType.DUPLICATE_ELECTRONIC_REPORT_CODE': '电子报告提取码重复',
  'pages.ledger.list.directConnectFailureType.RAS_ERROR': '咕咕平台异常',
  'pages.ledger.list.directConnectFailureType.SYSTEM_ERROR': '系统异常',

  'pages.system.user.col.username': '用户名',
  'pages.system.user.col.workNo': '工号',
  'pages.system.user.col.realName': '姓名',
  'pages.system.user.ph.realName': '请输入姓名进行模糊查询',
  'pages.system.user.col.email': '邮箱',
  'pages.system.user.col.phone': '手机号',
  'pages.system.user.selectToDelete': '请选择要删除的用户',
  'pages.system.user.batchDeleteFail': '批量删除失败',
  'pages.system.user.downloadTemplateLoading': '正在下载模板…',
  'pages.system.user.templateFileName': '用户导入模板.xlsx',
  'pages.system.user.templateDownloadSuccess': '模板下载成功',
  'pages.system.user.templateDownloadFail': '模板下载失败，请稍后重试',
  'pages.system.user.uploadExcelOnly': '请上传Excel文件（.xlsx或.xls格式）',
  'pages.system.user.fileTooLarge': '文件大小不能超过10MB',
  'pages.system.user.importDone': '用户导入完成',
  'pages.system.user.importFail': '导入失败',
  'pages.system.user.importFailRetry': '导入失败，请稍后重试',
  'pages.system.user.resetPwdTitle': '确认重置密码',
  'pages.system.user.resetPwdContent': '确定要重置用户"{name}"的密码吗？',
  'pages.system.user.resetPwdOk': '确认重置',
  'pages.system.user.resetPwdSuccess': '密码重置成功',
  'pages.system.user.resetPwdFail': '密码重置失败',
  'pages.system.user.resetPwdFailRetry': '密码重置失败，请稍后重试',

  'pages.system.user.col.nickname': '昵称',
  'pages.system.user.ph.nickname': '请输入昵称进行模糊查询',
  'pages.system.user.col.gender': '性别',
  'pages.system.user.gender.male': '男',
  'pages.system.user.gender.female': '女',
  'pages.system.user.gender.unknown': '未知',
  'pages.system.user.col.roles': '角色',
  'pages.system.user.unassigned': '未分配',
  'pages.system.user.col.organization': '所属机构',
  'pages.system.user.ph.organization': '请选择机构',
  'pages.system.user.col.dept': '部门',
  'pages.system.user.ph.dept': '请选择部门',
  'pages.system.user.col.status': '状态',
  'pages.system.user.col.createTime': '创建时间',
  'pages.system.user.col.action': '操作',
  'pages.system.user.action.edit': '编辑',
  'pages.system.user.action.resetPwd': '重置密码',
  'pages.system.user.action.delete': '删除',
  'pages.system.user.exportTemplate': '导出模板',
  'pages.system.user.import': '导入',
  'pages.system.user.addUser': '新增用户',
  'pages.system.user.deleteSuccess': '删除成功',
  'pages.system.user.deleteFail': '删除失败',
  'pages.system.user.confirmToggleTitle': '确认{action}',
  'pages.system.user.confirmToggleContent': '确定要{action}该用户吗？',
  'pages.system.user.userNamed': '用户"{name}"',
  'pages.system.user.userBracketNamed': '用户【{name}】',
  'pages.system.user.batchUsers': '选中的 {count} 个用户',
  'pages.system.user.deleteBatchSuccess': '成功删除 {count} 个用户',
  'pages.system.user.resetPwdContentInitial': '确定要重置该用户的密码为初始密码吗？',
  'pages.system.user.tableSelected': '已选择 {count} 项',
  'pages.system.user.batchDeleteWithCount': '批量删除 ({count})',
  'pages.system.user.cancelSelection': '取消选择',
  'pages.system.user.importModalTitle': '导入用户',
  'pages.system.user.importProcessingFile': '正在处理文件，请稍候…',
  'pages.system.user.importDragText': '点击或拖拽文件到此区域上传',
  'pages.system.user.importFileHintLong':
    '支持单个 Excel 文件上传，文件格式：.xlsx、.xls，文件大小不超过 10MB',
  'pages.system.user.importRunning': '正在导入用户数据…',
  'pages.system.user.importRunningHint': '请耐心等待，处理完成后将显示导入结果',
  'pages.system.user.importInstructionsTitle': '导入说明：',
  'pages.system.user.importInstruction1': '请先下载模板文件，按照模板格式填写用户信息',
  'pages.system.user.importInstruction2': '必填字段：用户名、姓名、邮箱、手机号',
  'pages.system.user.importInstruction3': '性别：男/女/未知 或 1/2/3',
  'pages.system.user.importInstruction4': '角色和机构信息请填写正确的名称',
  'pages.system.user.importInstruction5': '导入过程中如有错误，系统会生成失败文件供下载查看',
  'pages.system.user.deptUnnamed': '未命名部门',

  // 批量询价
  'pages.inquiryBatch.downloadTemplate': '下载模板',
  'pages.inquiryBatch.uploadExcel': '上传 Excel',
  'pages.inquiryBatch.downloadingTemplate': '正在下载模板…',
  'pages.inquiryBatch.templateDownloadSuccess': '模板下载成功',
  'pages.inquiryBatch.templateDownloadFail': '模板下载失败',
  'pages.inquiryBatch.uploadModalTitle': '上传批量询价 Excel',
  'pages.inquiryBatch.uploadStart': '开始询价',
  'pages.inquiryBatch.uploadDragText': '点击或拖拽文件到此区域上传',
  'pages.inquiryBatch.uploadFileHint': '支持 .xlsx、.xls 格式，文件大小不超过 10MB，单次最多 500 行',
  'pages.inquiryBatch.uploadInstruction1': '请先下载模板，按 17 列表头填写数据后上传',
  'pages.inquiryBatch.uploadInstruction2': '仅「总建筑面积」参与国信达估价，为空时默认 100㎡',
  'pages.inquiryBatch.uploadInstruction3': '存在进行中的任务时无法新建，请等待其完成',
  'pages.inquiryBatch.uploadExcelOnly': '只能上传 Excel 文件',
  'pages.inquiryBatch.uploadSizeLimit': '文件大小不能超过 10MB',
  'pages.inquiryBatch.uploadSelectFile': '请选择要上传的文件',
  'pages.inquiryBatch.uploadFail': '上传失败',
  'pages.inquiryBatch.uploadSuccess': '任务已创建，正在处理',
  'pages.inquiryBatch.viewExistingTask': '查看进行中任务',
  'pages.inquiryBatch.viewProgress': '查看进度',
  'pages.inquiryBatch.downloadResult': '下载结果',
  'pages.inquiryBatch.resultDownloadSuccess': '结果文件下载成功',
  'pages.inquiryBatch.resultDownloadFail': '结果文件下载失败',
  'pages.inquiryBatch.jobTitle': '批量询价任务进度',
  'pages.inquiryBatch.jobCloseTitle': '任务仍在执行中',
  'pages.inquiryBatch.jobCloseContent': '关闭后任务仍在后台执行，可稍后从列表查看进度。确定关闭吗？',
  'pages.inquiryBatch.jobCompletedSuccess': '批量询价已全部完成',
  'pages.inquiryBatch.jobCompletedPartial': '批量询价部分完成，请下载结果查看失败明细',
  'pages.inquiryBatch.jobCompletedFailed': '批量询价全部失败',
  'pages.inquiryBatch.pollFail': '查询任务进度失败',
  'pages.inquiryBatch.failureItemsTitle': '失败行明细',
  'pages.inquiryBatch.failureItemsEmpty': '暂无失败行',
  'pages.inquiryBatch.col.inquiryBatchId': '任务 ID',
  'pages.inquiryBatch.col.status': '状态',
  'pages.inquiryBatch.col.totalCount': '总行数',
  'pages.inquiryBatch.col.processedCount': '已处理',
  'pages.inquiryBatch.col.successCount': '成功',
  'pages.inquiryBatch.col.failureCount': '失败',
  'pages.inquiryBatch.col.pendingCount': '未处理',
  'pages.inquiryBatch.col.progressPercent': '进度',
  'pages.inquiryBatch.col.startTime': '开始时间',
  'pages.inquiryBatch.col.endTime': '完成时间',
  'pages.inquiryBatch.col.action': '操作',
  'pages.inquiryBatch.col.rowIndex': 'Excel 行号',
  'pages.inquiryBatch.col.projectName': '项目名称',
  'pages.inquiryBatch.col.inquiryId': '询价记录 ID',
  'pages.inquiryBatch.col.errorMsg': '失败原因',
  'pages.inquiryBatch.status.PENDING': '待处理',
  'pages.inquiryBatch.status.RUNNING': '执行中',
  'pages.inquiryBatch.status.SUCCESS': '全部成功',
  'pages.inquiryBatch.status.PARTIAL': '部分成功',
  'pages.inquiryBatch.status.FAILED': '全部失败',
  'pages.inquiryBatch.status.CANCELLED': '已取消',
  'pages.inquiryBatch.search.inquiryTime': '询价时间',
  'pages.inquiryBatch.search.status': '询价状态',
  'pages.inquiryBatch.ph.status': '请选择询价状态',
};
